import React from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import { ActNow, Layout, Pagination, PostCard } from '../components/common'
import { MetaData } from '../components/common/meta'
import { Col, Container, Row } from 'react-bootstrap'
// import DataBlogImage from '../images/data-blog-block.png'

const Blog = ({ data, location, pageContext }) => {
    const posts = data.allGhostPost.edges
    const post = data.ghostPage || {}

    return (
        <Layout headerClass="header-grey" footerClass="large">
            <MetaData
                data={data}
                location={location}
                type="website"
            />
            <section className="blog-section-1">
                <Container>
                    <Row>
                        {/*<Col md={6} sm={12} style={{ textAlign: 'center' }}>
                            <img className="left-block" src={DataBlogImage} alt={post.title}/>
                        </Col>*/}
                        <Col md={12} sm={12} className="right-column">
                            <h1> {post.title} </h1>
                            <p className="general-content">
                                {post.excerpt}
                            </p>
                        </Col>
                    </Row>
                </Container>
            </section>
            <div className="blog-main">
                <div className="container blog-main--articles-wrapper">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="row">
                                {posts.map(({ node }, index) => (<PostCard post={node} key={index} />))}
                            </div>
                            <Pagination pageContext={pageContext} />
                        </div>
                    </div>
                </div>
            </div>
            <ActNow/>
        </Layout>
    )
}

Blog.propTypes = {
    data: PropTypes.shape({
        allGhostPost: PropTypes.shape({
            edges: PropTypes.array.isRequired,
        }).isRequired,
        ghostPage: PropTypes.object,
    }).isRequired,
    location: PropTypes.object.isRequired,
    pageContext: PropTypes.object.isRequired,
}

export default Blog

export const pageQuery = graphql`
  query GhostBlogPostQuery($limit: Int!, $skip: Int!) {
    ghostPage(slug: { eq: "blog" }) {
        ...GhostPageFields
    }
    allGhostPost(
        sort: { order: DESC, fields: [published_at] },
        limit: $limit,
        skip: $skip,
    ) {
      edges {
        node {
          ...GhostPostFields,
          feature_image_sharp {
              childImageSharp {
                  fluid(maxWidth: 800) {
                    ...GatsbyImageSharpFluid
                  }
                }
          }
          primary_author {
              feature_image_sharp {
                  childImageSharp {
                      fixed(width: 50, height: 50) {
                        ...GatsbyImageSharpFixed
                      }
                    }
              }
          }
        }
      }
    }
  }
`
